import { Suspense } from "react";
// GLOBAL CUSTOM COMPONENTS
import MatxLoading from "app/components/MatxLoading";

export default function MatxSuspense({ children }) {
  return <Suspense fallback={<MatxLoading />}>{children}</Suspense>;
}
